import { styled } from "@mui/material";

const StyledBannerImage = styled("img")({
  width: "100%",
  height: "56.25vw",
});

export default StyledBannerImage;
